import React, { memo } from 'react'
import { Box, Link, Typography } from 'transfix-ui/core'
import { ICarrierPaymentBill } from 'types'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { ClockIcon, CheckFilledIcon } from 'transfix-icons'
import { EPaymentState } from './constants'
import { SidebarItem, SidebarLabel } from './sidebar'

interface IPaymentStatusProps {
  bills: ICarrierPaymentBill[]
}

export const PaymentStatus = memo<IPaymentStatusProps>(({ bills }) => {
  const { trackEvent } = useFMSAnalytics()
  const fileClickHandler = (url: string) => {
    window.open(url, '_blank')
    trackEvent('Load', 'CLICKED_BILL_PDF_FROM_LOAD_DETAILS')
  }
  const sortedBills = bills.sort((a, b) => b.fileName.localeCompare(a.fileName))

  const getPaymentStatus = (status?: EPaymentState): string => {
    switch (status) {
      case EPaymentState.delivered:
        return 'Pending'
      case EPaymentState.drafted:
      case EPaymentState.paid:
        return 'Paid'
      default:
        return ''
    }
  }

  const getPaymentStatusIcon = (status?: EPaymentState) => {
    switch (status) {
      case EPaymentState.delivered:
        return <ClockIcon data-test='clock-icon' color='coolGray5' size='medium' />
      case EPaymentState.drafted:
      case EPaymentState.paid:
        return <CheckFilledIcon data-test='check-filled-icon' color='green2' size='medium' />
      default:
        return null
    }
  }

  return (
    <SidebarItem>
      <SidebarLabel BoxProps={{ pb: 0.5 }}>Payment Status</SidebarLabel>
      {sortedBills.map(bill => (
        <Box display='flex' alignItems='flex-start' key={bill.id} data-test='bill-container'>
          <Box minWidth='80px'>
            <Link onClick={() => fileClickHandler(bill.url)} rel='noopener noreferrer'>
              {bill.fileName}
            </Link>
          </Box>
          <Box display='flex' marginLeft='40px'>
            <Typography variant='subtitle2' color='textSecondary'>
              {getPaymentStatus(bill.state)}
            </Typography>
            <Box display='flex' alignItems='center' marginLeft='5px'>
              {getPaymentStatusIcon(bill.state)}
            </Box>
          </Box>
        </Box>
      ))}
    </SidebarItem>
  )
})
